import isEmpty from 'lodash/isEmpty';

/**
 * Метод расширяющий аналог из lodash, добавляется поддержка типа number и string.
 * - Число является "пустым" если оно NaN или isFinite
 * - Строка является "пустой" если ее длина равна 0
 * - false считается пустым значением
 * - null и undefined считаются "пустыми" значенияем
 * @param {unknown} value
 * @returns {boolean}
 */
const isEmptyExt = (value: unknown): boolean => {
    if (value === null || value === undefined) return true;

    if (typeof value === 'number') {
        if (Number.isNaN(value)) return true;
        if (value === 0) return true;

        return false;
    }

    if (typeof value === 'string') {
        return value.length === 0;
    }

    if (typeof value === 'boolean') {
        return !value;
    }

    return isEmpty(value);
};

export default isEmptyExt;
